// @ts-nocheck

import { isAndroid, isEmbedded } from '../../lib/useragent';
import { QRActionTypes } from '../../types/actions/qr';
import QRPlugin from '../../utils/plugins/qr';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

export const handledActionTypes = [QRActionTypes.REQUIRE_QR_SCAN];

const miscMiddlewareHandler = async ({ action, params: { history } }: HandlerProps) => {
  if (handledActionTypes.indexOf(action.type) !== -1) {
    if (action.type === QRActionTypes.REQUIRE_QR_SCAN) {
      if (isAndroid && isEmbedded) {
        try {
          const hasPermissions = await QRPlugin.requestCameraPermission();

          if (hasPermissions) {
            history.push(RoutesRedirectionFactory.getScannerRouteConfig());
          }
        } catch (error) {
          console.error(error);
          history.goBack();
        }
      } else {
        history.push(RoutesRedirectionFactory.getScannerRouteConfig());
      }
    }
  }
};

export default miscMiddlewareHandler;
